import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'editLoggedbyexecutive',
  components: {
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      regionName: '',
      hubName: '',
      currentHubName: '',
      destinationHubName: '',
      bagCondition: '',
      DEPSbagCondition: '',
      OctroiMRP: '',
      Clientname: '',
      productDescription: '',
      STDreason: '',
      description: '',
      hubOrigin: '',
      Currenthub: '',
      Destinationhub: '',
      lastService: '',
      currentRegion: '',
      hubzoneid: '',
      newhublist: [],
      StatusList: [{
        value: 4,
        label: 'Accidental Damage'
      }, {
        value: 6,
        label: 'Damage due to Rain'
      }, {
        value: 5,
        label: 'Fragile Items'
      }, {
        value: 3,
        label: 'Improper Handling'
      }, {
        value: 1,
        label: 'Liquid Spillage'
      }, {
        value: 7,
        label: 'Natural Calamity'
      }, {
        value: 8,
        label: 'Pilferage'
      }, {
        value: 2,
        label: 'Poor Packaging'
      }],
      vStatusList: [{
        value: "Intact",
        label: 'Intact'
      }, {
        value: "Torn/Damage",
        label: 'Torn/Damage'
      }, {
        value: "WithoutSeal",
        label: 'WithoutSeal'
      }],
      hubdroplist: [],
      newhubs: '',
      hublist: [],
      attachment: null,
      displaytable: false,
      imagesarr: [],
      attachment: null,
      displaytable: false,
      description: '',
      image: '',
      username: '',
      showupload: false,
      statuss: '',
      // try
      path: `${awsBucketName}/1234/wallpaperflare.com_wallpaper-1.jpg`,
      //   fname1: 'download.jpeg',
      fname1: 'wallpaperflare.com_wallpaper-1.jpg',
      imgdata: '',
      showModal: false,
      awbnumber: '',
      ids: '',
      currenthubid: '',
      OctroiMRP: '',
      bagcondition: '',
      Clientname: '',
      FileSelected:null


    };
  },
  mounted() {
    this.hubOrigin = this.$route.query.originhubname;
    this.Currenthub = this.$route.query.currenthubname;
    this.currenthubid = this.$route.query.currenthubid.toString()
    this.Destinationhub = this.$route.query.finaldestinationname;
    this.currentRegion = this.$route.query.regionname;
    this.OctroiMRP = this.$route.query.netvalue;
    this.bagcondition = this.$route.query.bagcondition;
    this.Clientname = this.$route.query.Clientname;
    this.hubzoneid = this.$route.query.hubzoneid;
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    this.awbnumber = this.$route.query.awb;
    this.statuss = this.$route.query.status;
    this.ids = this.$route.query.id;

  },

  methods: {

    resetForm() {
      if(this.imagesarr.length!=[]){
        this.$alertify.error("Please Delete image")

      }
      this.DEPSbagCondition = '',
        this.STDreason = '',
        this.description = '',
        this.$validator.reset(); this.errors.clear();
    },

    onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;

    },
    uploadFile() {
      if (this.attachment == null) {
        this.$alertify.error("Please Choose Image ");

      }
      if (this.attachment.size > 614400) {
        this.$alertify.error("Please Upload Document Less Than 600KB");

      }
      else {
        if (this.imagesarr.length >= 3) {
          this.$alertify.error("Only Three Image Upload");
        }
        else {

          let status = 0
          if (this.statuss !== undefined) {
            if (this.statuss === null || this.statuss === undefined) {
              this.statuss = 0;
            }
            status = this.statuss;
          }
          if (this.attachment.type == "image/jpeg" ||
            this.attachment.type == "image/jpg" || this.attachment.type == "image/png" || this.attachment.type == "image/gif" || this.attachment.type == "") {
            var form = new FormData();
            form.append('file', this.attachment);
            form.append('shippingid', this.awbnumber);
            form.append('primaryKey', 123),
              form.append('status', this.statuss);
            var inputpayload = form;
            var UploadedImage = this.attachment.name


            axios({
              method: 'post',
              url: `${apiUrl.api_url}uploadimage`,
              data: inputpayload,
              headers: {
                'Content-Type': 'application/json',
              },
            }).then((result) => {
              this.imagesarr.push({ file: UploadedImage, imgPath: result.data.data });
              if (this.imagesarr.length > 0 && this.imagesarr.length <= 3) {
                this.displaytable = true;
              }
              if (result.data.errorCode == 0) {
                this.$alertify.success('Image uploaded successfully');
              }
            },

              (error) => {
                this.show = false;
                this.displaytable = false;
                console.error(error);
              });
            inputpayload = null;
            this.attachment = null;
            this.FileSelected = null;
          }

          else {
            this.$alertify.error("Please upload only Allowed file format");

          }
        }
      }
    },
    downloadImage(filePath) {
      this.imgData = filePath;
      this.showModal = true;
    },

    closeImage() {
      this.showModal = false;
    },

    deleteImage(i) {
      let fileName = this.imagesarr[i].file ? this.imagesarr[i].file : '';
      const currentdate = moment(new Date()).format("DD_MM_YYYY");

      // this.input = ({
      //   key: `${awsBucketName}/123${this.awbnumber}/${currentdate}_${fileName}`,
      //   file: fileName
      // });
      this.input = ({
        key: `STD/${this.awbnumber}/${currentdate}_${fileName}`,
        file: fileName
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}deleteimage`,
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((result) => {
        if (result.data.errorCode == 0) {
          if (i > -1) {
            this.imagesarr.splice(i, 1);
            this.$alertify.error(result.data.msg);
          }
        } else {
          console.error(result.data.data);
          this.$alertify.error(result.msg);
        }
      },
        (error) => {
          console.error(error);
        });
    },
    Backinvestigation() {
      if (this.imagesarr.length != []) {
        this.$alertify.error("Please Delete image")

      }
      else{
      this.$router.push({ path: '/DamagedByOperations' });
      }
    },
    updatedata() {
      if (!this.description) {
        this.$alertify.error("Please fill Description.")
      }
      else if (!this.DEPSbagCondition.value) {
        this.$alertify.error("Please Select DEPS Bag Condition.")
      }
      else if (!this.STDreason.value) {
        this.$alertify.error("Please Select STD Reason.")
      }
      else if(this.imagesarr.length<=2){
        this.$alertify.error("Please Upload Three images")

      }
      else {
        let currentdate = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
        // if(this.STDreason.value){
        // let sid = this.STDreason.value;
        // var Statusid = sid.toString()
        // }
        this.input = ({
          ShippingID: this.awbnumber,
          CurrentHubID: this.currenthubid,
          ShipmentVerifiedAs: this.username,
          Status: "1",
          BucketTypeCode: 4,
          HubZoneID: 2,
          STDbagcondition: this.DEPSbagCondition.label,
          StatusMarkedFrom: "Web",
          Comments: this.description,
          LastModifiedBy: this.username,
          LastModifiedDate: currentdate,
          RequestFrom: "Finance"//need

          //IsReattempt: "",
          //RequestFrom: ""
        })
        axios({
          method: 'post',
          url: apiUrl.api_url + 'AddToInvestigation',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
          if (result.data.code == 200) {
            this.$alertify.success(result.data.message)
            this.$router.push({ path: '/DamagedByOperations' });
          }
          else {
            this.$alertify.error(result.data.message)
          }
        })
      }//else
    }

  },
};



// WEBPACK FOOTER //
// ./src/views/components/EditExcutive/EditExcutive.component.js